


























































import {Component, Prop, Vue, Watch} from 'vue-property-decorator';
import {Subjects} from '@/components/simpleSlide/subject';
import SustainabilityQuestions from '@/components/gt/SustainabilityQuestions_.vue';
import SustainabilityProcess from '@/components/gt/SustainabilityProcess_.vue';
import SustainabilityImpact from '@/components/gt/SustainabilityImpact_.vue';
import SustainabilityImpact2409 from '@/components/gt/SustainabilityImpact2409.vue';
import ServiceTree from '@/components/ServiceTree.vue';
import ContentTree from '@/components/ContentTree.vue';
@Component({
  components: {
    SustainabilityImpact,
    SustainabilityProcess,
    SustainabilityQuestions,
    SustainabilityImpact2409,
    ServiceTree,
    ContentTree,
  },
  computed: {
    Subjects() {
      return Subjects;
    },
  },
})
export default class ContentSubject extends Vue {
  @Prop() readonly subjects!: string[];
  @Prop() readonly nav!: any[];
  @Prop() readonly idx!: number;
  @Prop() readonly currentLanguage!: any;

  navigateTo(i: any) {
    this.nav[this.idx][1] = i;
    this.nav.push([-1, null]);
  }

  imgSrc(type: string) {
    return '/static/gt/image/produktblad/' + type + '.png';
  }

  get current(): any {
    if (!this.nav[this.idx]) {
        return null;
    }
    if (this.subjects.length === 1) {
        return Subjects.getSubjectById(this.subjects[0]);
    }
    if (this.nav[this.idx][1] === null) {
        return null;
    }
    return Subjects.getSubjectById(this.subjects[this.nav[this.idx][1]]);
  }

  get style(): string {
    return this.current === null ? 'xlist-container' : 'content-subcontent ' + (this.current.type === 'image' ? 'primary' : 'gray');
  }
}
